import * as mainTerms from '../../mainTerms';

const adDef = mainTerms.Setting.ad.default;

const adFolderDef = mainTerms.Setting.adFolder.default;
const inventoryDef = mainTerms.Setting.inventory.default;

export const ad =  {
    landingURL: {
        label: '랜딩 URL',
        error: {
            required: '광고에 연결시킬 랜딩 URL을 설정해주세요',
        },
    },
    creativeMatch: {
        label: adDef + ' 연결',
        column: {
            emptyText: '사용 가능한 '+ adDef +'가 없습니다.',
            inventory: inventoryDef + ' 이름 및 포맷',
            toUse: '사용할 ' + adDef,
            loaded: '현재 불러온 ' + adDef,
        }
    },
    impWeight: {
        label: '노출 가중치',
        placeholder: '노출 가중치 선택',
        description: '광고 노출 시 본 캠페인을 우선 노출하기 위해 가중치를 설정하실 수 있습니다.'
    },
    loadCreativeFolder: {
        title: adFolderDef + ' 불러오기',
        query: {
            placeholder: adFolderDef + '이름',
        },
        column: {
            name: adFolderDef + '이름',
            scale: adDef + '수',
            updateDate: '수정한 시간',
        }
    },
    loadedAdFolder: {
        label: '현재 불러온 ' + adFolderDef,
    }
}